import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
var title = 'Flash HR';
export default function getPageTitle(key) {
  if (!key) return title;
  var hasKey = Vue.prototype.$t(key);
  if (hasKey) {
    return "".concat(hasKey, " - ").concat(title);
  }
  return "".concat(title);
}